import useAppState from "@saleor/hooks/useAppState";
import useUser from "@saleor/hooks/useUser";
import { checkUserPermissionsCanAccessMalls } from "@saleor/utils/handlers/userHandler";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import { MallListUrlQueryParams, MallShippingLogsSortField } from "./urls";
import MallCreateView from "./views/MallCreate";
import MallDetailsView from "./views/MallDetails";
import MallListComponent from "./views/MallList";

const MallList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params: MallListUrlQueryParams = {
    ...qs
  };

  return <MallListComponent params={params} />;
};

const MallDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substring(1));
  const params: any = asSortParams(
    qs,
    MallShippingLogsSortField,
    MallShippingLogsSortField.created_date,
    false
  );

  return <MallDetailsView id={decodeURIComponent(id)} params={params} />;
};

const Component = () => {
  const intl = useIntl();
  const user = useUser();
  const [accessCheckComplete, setAccessCheckComplete] = React.useState(false);

  const checkAccessPermission = () => {
    if (!checkUserPermissionsCanAccessMalls(user?.user?.userPermissions)) {
      const [, dispatchAppState] = useAppState();
      dispatchAppState({
        payload: {
          error: "unhandled"
        },
        type: "displayError"
      });
    }
    setAccessCheckComplete(true);
  };

  React.useEffect(() => {
    if (!accessCheckComplete) {
      checkAccessPermission();
    }
  }, [user?.user?.userPermissions]);

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Mall List",
          description: "Mall List"
        })}
      />
      <Routes>
        <Route path={""} element={<MallList />} />
        <Route path={"add"} element={<MallCreateView />} />
        <Route path={":id"} element={<MallDetails />} />
      </Routes>
    </>
  );
};

export default Component;
